import CrudRepository from './CrudRepository'
import Repository from './Repository'
export default class OffersCategoriesRepository extends CrudRepository {
  constructor () {
    super('core/api/offers/categories/web')
  }

  async get () {
    // const token = localStorage.getItem('token')
    // const requested = { Authorization: 'Bearer ' + token }
    // const data = await Repository.get(`${this.resource}`, token ? { headers: requested } : {})
    const data = await Repository.get(`${this.resource}`)
    return data.data
  }
}
